<template>
  <FormulateForm v-model="form" :errors="formErrors" :schema="schema" @created="onFormCreated" @submit="submitForm" />
</template>

<script>
export default {
  props: {
    address: {
      type: String,
      required: true,
    },
    propertyTypes: {
      type: Object,
      required: true,
    },
    defaults: {
      type: Object,
      required: false,
    },
    changeMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        propertyType: 'flat',
        price: 0,
        garages: 0,
        storageRooms: 0,
      },
      formErrors: null,
    };
  },
  computed: {
    addressField() {
      return {
        component: 'div',
        class: 'property__address-field',
        children: [
          {
            name: 'address',
            label: 'Dirección de la vivienda',
            type: 'text',
            readonly: true,
            value: this.address,
          },
          {
            type: 'button',
            label: 'Cambiar dirección',
            '@click': this.back,
          },
        ],
      };
    },
    subFields() {
      return {
        component: 'div',
        class: 'property__sub-fields',
        children: [
          {
            component: 'div',
            class: 'property__sub-fields__container',
            children: [
              this.propertyTypeField,
              this.priceField,
              this.garagesStoragesNotice,
              this.extraGaragesField,
              this.extraStorageRoomField,
            ],
          },
        ],
      };
    },
    propertyTypeField() {
      return {
        name: 'propertyType',
        type: 'radio',
        class: 'formulate-input',
        label: 'Tipo de inmueble',
        options: this.propertyTypes,
      };
    },
    priceField() {
      return {
        name: 'price',
        label: 'Precio del inmueble',
        type: 'currency',
        validation: `required|number|min:35000|max:10000000`,
        helpPosition: 'before',
        placeholder: '0 €',
        currency: 'EUR',
        locale: 'es',
        inputmode: 'numeric',
        showPlaceholder: true,
        'validation-messages': {
          required: 'El campo es obligatorio.',
          number: 'El input introducido debería ser númerico.',
          min: 'El precio debería ser, al menos, 35.000€',
          max: 'El precio debe ser de 10.000.000€ o menos',
        },
      };
    },
    garagesStoragesNotice() {
      return {
        component: 'div',
        class: 'property__garages-storages__container',
        children: [
          {
            component: 'div',
            class: 'property__garages-storages__notice',
            children: '¿Se quieren tasar locales en otra dirección?',
          },
          {
            component: 'div',
            class: 'popover popover__info',
            'data-bs-toggle': 'tooltip',
            title:
              'Los locales anexos (extra) son los garajes o trasteros con dirección o número de finca registral diferente a la vivienda. La tasación de estos locales se calcula separadamente de la tasación de la vivienda.',
          },
        ],
      };
    },
    extraGaragesField() {
      return {
        name: 'garages',
        label: 'Nº de garajes extra (opcional)',
        type: 'number',
        validation: `number`,
        showPlaceholder: true,
        'validation-messages': {
          required: 'El campo es obligatorio.',
          number: 'El input introducido debería ser númerico.',
        },
      };
    },
    extraStorageRoomField() {
      return {
        name: 'storageRooms',
        label: 'Nº de trasteros extra (opcional)',
        type: 'number',
        validation: `number`,
        showPlaceholder: true,
        'validation-messages': {
          required: 'El campo es obligatorio.',
          number: 'El input introducido debería ser númerico.',
        },
      };
    },
    backButton() {
      return {
        component: 'a',
        class: 'btn btn-ghost btn-lg',
        children: 'Volver',
        '@click': this.back,
      };
    },
    submitButton() {
      return {
        type: 'submit',
        name: 'submit',
        label: this.changeMode ? 'Cambiar' : 'Continuar',
      };
    },
    buttons() {
      return {
        component: 'div',
        class: 'btn-container',
        children: this.changeMode ? [this.submitButton] : [this.backButton, this.submitButton],
      };
    },
    schema() {
      return [this.addressField, this.subFields, this.buttons];
    },
  },
  methods: {
    onFormCreated() {
      this.$nextTick(() => window.initTooltip());
    },
    submitForm() {
      this.$emit('input', this.form);
      this.$emit('nextStep');
    },
    back() {
      this.$emit('prevStep');
    },
  },
  created() {
    if (this.defaults) {
      this.form = this.defaults;
    }
  },
};
</script>
